/* eslint-disable import/no-extraneous-dependencies, import/prefer-default-export */
import { writable } from "svelte/store";

const isAuthenticated = writable(null);
const user = writable({});
const userDetail = writable({});
const error = writable();
const session = writable();

export default { isAuthenticated, user, userDetail, error, session };
